import { type FC } from 'react'

import { F0Dialog } from '@factorialco/f0-react'
import { Carousel } from '@factorialco/f0-react/dist/experimental'
import { isProductCatalogUrl } from 'modules/it_management/lib/graphqlProductCatalogContext'
import { Box } from '@factorialco/deprecated-design-system'

interface DeviceImageShowcaseProps {
  images: string[]
  activeIndex: number
  onClose: () => void
}

export const DeviceImageShowcase: FC<DeviceImageShowcaseProps> = ({
  images,
  activeIndex,
  onClose,
}) => {
  // Reorder images so activeIndex appears first while maintaining order
  const reorderedImages = [...images.slice(activeIndex), ...images.slice(0, activeIndex)]

  return (
    <F0Dialog isOpen onClose={onClose} width="lg">
      <Box paddingX="s16">
        <Carousel
          columns={
            images.length > 1
              ? {
                  xs: 1,
                }
              : { default: 1 }
          }
        >
          {reorderedImages.map((imageUrl: string, idx: number) => (
            <img
              key={idx}
              src={imageUrl}
              alt={`image-${idx + 1}`}
              crossOrigin={isProductCatalogUrl(imageUrl) ? 'use-credentials' : undefined}
              className="w-full h-auto object-contain aspect-video"
              style={{
                maxHeight: '300px',
              }}
            />
          ))}
        </Carousel>
      </Box>
    </F0Dialog>
  )
}
